import { PrivacyContent } from "@/components/PrivacyContent";

export default function Privacy() {
  return (
    <main className="min-h-screen p-8 max-w-3xl mx-auto">
      <h1 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl mb-4">Privacy</h1>
      <PrivacyContent />
    </main>
  );
}
